/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useNavigate } from "react-router-dom";
import {connect} from "react-redux";
import { setBackButtonShow,editFirstName,editLastName,editUserName,editDescription,editBirthday } from "../../redux/actions/actions.js";
import axios from "axios";

class Profile_Edit extends React.Component {
    constructor() {
        super();
        this.state = {
            id: "",
            firstName: "",
            lastName: "",
            userName: "",
            description: "",
            birthday: "",
            message: "",
            classTitle: ""
        }
    }
    componentDidMount() {
        this.setState({id:this.props.user.id});
        this.setState({firstName:this.props.user.firstName});
        this.setState({lastName:this.props.user.lastName});
        this.setState({userName:this.props.user.userName});
        this.setState({birthday:this.props.user.birthday});
        this.setState({description:this.props.user.description});
    }
    // shouldComponentUpdate(prevProps,prevState) {
    //     if (prevState.firstName !== this.state.firstName) {
    //         return true;
    //     } else {
    //         return false;
    //     }
    // }
    componentWillUnmount() {
        this.props.onSetBackButtonShow("hide");
    }
    render() {
        const {id,firstName,lastName,userName,description,birthday,message,classTitle} = this.state;
        const {user,color_background,color_button,edit_firstName,edit_lastName,edit_userName,edit_description,edit_birthday,onEditFirstName,onEditLastName,onEditUserName,onEditDescription,onEditBirthday} = this.props;
        const handleSubmit = async (e) => {
            e.preventDefault();
            try {
                const result = await axios.put(`/profile/update?q=${id}`,{
                    firstName:edit_firstName,
                    lastName:edit_lastName,
                    userName:edit_userName,
                    description:edit_description,
                    birthday:edit_birthday
                });
                this.setState({classTitle:"profile_edit_form_message_success"});
                this.setState({message:result.data.msg});
                // setTimeout(() => {
                //     navigate("/profile");
                // },1500);
            } catch (error) {
                this.setState({classTitle:"profile_edit_form_message_fail"});
                console.log(error);
            }
        };
        return(
            <div className="main_content_section_main main_content_section">
                <div className="profile_section">
                    <h1 className="profile_section_title">Edit profile</h1>
                    <form className="profile_edit_form" onSubmit={handleSubmit}>
                        <div className="profile_edit_form_div">
                            <label className="profile_edit_form_label" htmlFor="profile_edit_fname">First name</label>
                            <input value={edit_firstName || firstName} className={`profile_edit_form_input profile_edit_form_input_color profile_edit_form_input_fname profile_edit_form_input background_change_${color_background}`} type="text" name="fname" id="profile_edit_fname" placeholder={firstName} onChange={(e) => onEditFirstName(e.target.value)} />
                        </div>
                        <div className="profile_edit_form_div">
                            <label className="profile_edit_form_label" htmlFor="profile_edit_lname">Last name</label>
                            <input value={edit_lastName || lastName} className={`profile_edit_form_input profile_edit_form_input_color profile_edit_form_input_lname profile_edit_form_input background_change_${color_background}`} type="text" name="lname" id="profile_edit_lname" placeholder={lastName} onChange={(e) => onEditLastName(e.target.value)} />
                        </div>
                        <div className="profile_edit_form_div">
                            <label className="profile_edit_form_label" htmlFor="profile_edit_username">User name</label>
                            <input value={edit_userName || userName} className={`profile_edit_form_input profile_edit_form_input_color profile_edit_form_input_username profile_edit_form_input background_change_${color_background}`} type="text" name="username" id="profile_edit_username" placeholder={userName} onChange={(e) => onEditUserName(e.target.value)} />
                        </div>
                        <div className="profile_edit_form_description_div">
                            <label className="profile_edit_form_label" htmlFor="profile_edit_description">Description</label>
                            <textarea value={edit_description || description} className={`profile_edit_form_input profile_edit_form_input_color profile_edit_form_input_description profile_edit_form_description background_change_${color_background}`} id="profile_edit_description" onChange={(e) => onEditDescription(e.target.value)} rows="4" name="description" placeholder={description} ></textarea>
                        </div>
                        <div className="profile_edit_form_div">
                            <label className="profile_edit_form_label" htmlFor="profile_edit_birthday">Birthday</label>
                            <input value={edit_birthday || birthday} className={`profile_edit_form_input profile_edit_form_input_color profile_edit_form_input_birthday profile_edit_form_input background_change_${color_background}`} type="date" name="birthday" id="profile_edit_birthday" placeholder={birthday} onChange={(e) => onEditBirthday(e.target.value)} />
                        </div>
                        <input className={`profile_edit_save_button profile_edit_button customizecolorchange_hover customizecolorchange_${color_button}`} type="submit" name="submit" id="profile_edit_submit" value="Save" />
                        <div className={`profile_edit_form_message ${classTitle}`}>{message}</div>
                    </form>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        color_button: state.getColorButton.color_button,
        color_background: state.getColorBackground.color_background,
        user: state.getUser.user,
        edit_firstName: state.editFirstName.edit_firstName,
        edit_lastName: state.editLastName.edit_lastName,
        edit_userName: state.editUserName.edit_userName,
        edit_description: state.editDescription.edit_description,
        edit_birthday: state.editBirthday.edit_birthday
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        onSetBackButtonShow: (text) => dispatch(setBackButtonShow(text)),
        onEditFirstName: (text) => dispatch(editFirstName(text)),
        onEditLastName: (text) => dispatch(editLastName(text)),
        onEditUserName: (text) => dispatch(editUserName(text)),
        onEditDescription: (text) => dispatch(editDescription(text)),
        onEditBirthday: (text) => dispatch(editBirthday(text))
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Profile_Edit);